import { IChatMessage } from '@cakeiteasy/web-utils';

/** Newest last. */
export function sortByCreatedAt(messages: IChatMessage[]): IChatMessage[] {
  return [...messages].sort((a, b) => (a.createdAt < b.createdAt ? -1 : a.createdAt > b.createdAt ? 1 : 0));
}

/**
 * Collapses duplicates by id, preferring the later entry — the refetched copy is the server's
 * current version of that message.
 *
 * This is what lets a full-list REST response, a reconnect backfill and incremental
 * socket pushes all merge without special cases.
 */
export function dedupeById(messages: IChatMessage[]): IChatMessage[] {
  const byId = new Map<number, IChatMessage>();

  messages.forEach((message) => byId.set(message.id, message));

  return Array.from(byId.values());
}

export function mergeChatMessages(history: IChatMessage[], live: IChatMessage[]): IChatMessage[] {
  return sortByCreatedAt(dedupeById([...history, ...live]));
}
